import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MemberAccount } from '../../../../models/transactions/member-account';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SortUtils } from '../../../../utils/sort-utils';
import { AccountTypeIdEnum } from '../../../../models/enum/shared/account-type-id.enum';
import { AccountTypeBucket } from '../../../../models/transactions/account-type-bucket';
import { FormControl, FormGroup } from '@angular/forms';

export type AccountTypeSelectionFormGroup = FormGroup<{
  accountType: FormControl<number>;
}>;

@Component({
  selector: 'app-account-type-selection-form',
  templateUrl: './account-type-selection-form.component.html',
  styleUrls: ['./account-type-selection-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountTypeSelectionFormComponent implements OnChanges {
  @Input() memberAccounts!: MemberAccount[];
  @Input() formGroup!: AccountTypeSelectionFormGroup;
  @Input() formSubmitted: boolean = false;

  private _memberAccounts = new BehaviorSubject<MemberAccount[]>([]);
  public memberAccounts$ = this._memberAccounts as Observable<MemberAccount[]>;

  public accountBuckets$: Observable<AccountTypeBucket[]> = this.memberAccounts$.pipe(
    map(accounts => {
      const accountBuckets = SortUtils.bucketBy(accounts ?? [], a => a?.typeId);
      const typeIds = Object.keys(accountBuckets).map(Number);
      return typeIds
        .sort((a, b) => a - b)
        .map(typeId => {
          const accountType = accounts.find(a => a.typeId === typeId)?.type;
          return accountType
            ? {
                accountTypeId: typeId as AccountTypeIdEnum,
                accountType,
                accounts: accountBuckets[typeId as AccountTypeIdEnum] ?? []
              }
            : undefined;
        })
        .filter((bucket): bucket is AccountTypeBucket => !!bucket);
    })
  );

  public customErrorMessages = {
    required: $localize`You must select which account type you are updating for`
  };

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.memberAccounts) {
      this._memberAccounts.next(this.memberAccounts);
    }
  }
}
